export default __webpack_public_path__ + "static/media/offer-chocolate@2x.d54ebcec.png";